// ** Reducers Imports
import navbar from './navbar'
import layout from './layout'
import auth from './authentication'
import nilaick from '@src/views/forms/nilai-capaian-kompetensi/store'
import sen from '@src/views/forms/sen/store'
import initialprojek from '@src/views/forms/initial-projek/store'
import projek from '@src/views/forms/profil-pancasila/store'
import projekKindergaten from '@src/views/forms/profil-pancasila-kindergaten/store'
import nilaiap from '@src/views/forms/aspek-perkembangan-anak/store'
import laporan from '@src/views/forms/laporan/store'
// import chat from '@src/views/apps/chat/store'
// import users from '@src/views/apps/user/store'
// import email from '@src/views/apps/email/store'
// import kanban from '@src/views/apps/kanban/store'
// import invoice from '@src/views/apps/invoice/store'
// import calendar from '@src/views/apps/calendar/store'
// import ecommerce from '@src/views/apps/ecommerce/store'
// import dataTables from '@src/views/tables/data-tables/store'
// import permissions from '@src/views/apps/roles-permissions/store'

const rootReducer = {
  auth,
  nilaick,
  initialprojek,
  projek,
  projekKindergaten,
  nilaiap,
  laporan,
  sen,
  //todo,
  // chat,
  // email,
  // users,
  // kanban,
  navbar,
  layout
  // invoice,
  // calendar,
  // ecommerce,
  // dataTables,
  // permissions
}

export default rootReducer

